export interface StatisticState {
  emailStatisticDetail: DetailItem[];
  emailStatisticDetailInfo: DetailItem | undefined;
  emailStatisticGroup: EmailGroupItem[];
  emailGroupings: {
    emailGroup: string[];
    emailGroupOptionally: string[];
    emailEventsGroupOptionally: string[];
  };
  eventTypeList: string[];
}

export interface DetailItem {
  id: string;
  create_date: string;
  originator: string;
  recipient: string;
  partner: string;
  service_provider: string;
  subject: string;
  status: string;
  error_code?: number;
}

export class EmailDetailItemInfo {
  id: string|null = null;
  create_date: string|null = null;
  sent_date?: string = undefined;
  delivery_date?: string = undefined;
  read_date?: string = undefined;
  defer_date?: string = undefined;
  external_id?: string = undefined;
  service_provider?: string = undefined;
  originator: string|null = null;
  recipient: string|null = null;
  parent_message_id?: string = undefined;
  parent_message_channel?: string = undefined;
  bulk_id?: number = undefined;
  partner: string|null = null;
  partner_user_login?: string = undefined;
  status: string|null = null;
  error_code?: number = undefined;
  error_description?: string = undefined;
  message_type?: string = undefined;
  subject?: string = undefined;
  priority?: number = undefined;
  partner_price?: string = undefined;
  provider_price?: string = undefined;
  broker_account_login?: string = undefined;
  template_id?: string = undefined;
  connection_type?: string = undefined;
  custom_data?: string;
  ext_id1?: string = undefined;
  ext_id2?: string = undefined;
  ext_id3?: string = undefined;
  ext_id4?: string = undefined;
  ext_id5?: string = undefined;
}

export class DetailFilterParams {
  message_direction:string = 'mt';
  date_from: string;
  date_to: string;
  originator?: string = undefined;
  recipient?: string = undefined;
  partner?: string = undefined;
  service_provider?: string = undefined;
  status?: string = undefined;
  error_code?: number = undefined;
  message_type?: string = undefined;
  sent_date_from?: string = undefined;
  sent_date_to?: string = undefined;
  deliver_date_from?: string = undefined;
  deliver_date_to?: string = undefined;
  template_id?: number = undefined;
  bulk_id?: number = undefined;
  broker_account_login?: string = undefined;
  partner_user_login?: string = undefined;
  id?: string = undefined;
  external_id?: string = undefined;
  ext_id1?: string = undefined;
  ext_id2?: string = undefined;
  ext_id3?: string = undefined;
  ext_id4?: string = undefined;
  ext_id5?: string = undefined;
  page_number: number = 1;
  type?: string;

  constructor(date_from: string, date_to: string) {
    this.date_from = date_from;
    this.date_to = date_to;
  }
}

// - - -

export interface EmailGroupItem {
  date?: string;
  originator?: string;
  service_provider?: string;
  partner?: string;
  template_id?: number;
  bulk_id?: number;
  delivered: number;
  read: number;
  not_delivered: number;
  transmitted: number;
  failed: number;
  rejected: number;
  deferred: number;
  total: number;
  partner_price: string;
  provider_price: string;
}

export class GroupFilterParams {
  message_direction: string = 'mt';
  date_from: string;
  date_to: string;
  group_by: string;
  template_id?: number|null = undefined;
  bulk_id?: number|null = undefined;
  message_type?: string|null = undefined

  constructor(date_from: string, date_to: string, group_by: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.group_by = group_by;
  }
}
